module.exports = __webpack_public_path__ + "img/eng-lqtafsir-3.c29f825c.webp";